import React from "react";
import "./Loading.css";

const Loading = (props) => {
  return (<span>{props.show && <div id="loading-container"><div className="fpds-ProgressSpinner"></div></div>}</span>
  );
};

export default Loading;